/**
 * AllAll 语音合成：speech-2.6-hd，POST /v1/audio/speech
 * 参数：model, input(必填), voice, voice_setting, pronunciation_dict, audio_setting, subtitle_enable
 */
var MODEL = 'speech-2.6-hd'

function defaultVoiceSetting(params) {
  var voiceId = params.voice_id || params.voice || 'male-qn-qingse'
  return {
    voice_id: voiceId,
    speed: typeof params.speed === 'number' ? params.speed : 1,
    vol: typeof params.vol === 'number' ? params.vol : 1,
    pitch: typeof params.pitch === 'number' ? params.pitch : 0,
    emotion: params.emotion || 'happy'
  }
}

function defaultAudioSetting(params) {
  return {
    sample_rate: params.sample_rate || 32000,
    bitrate: params.bitrate || 128000,
    format: (params.format || 'mp3').toLowerCase(),
    channel: params.channel != null ? Number(params.channel) : 1
  }
}

/**
 * 构建 POST /v1/audio/speech 的 JSON Body
 * @param {Object} params - input(必填), voice, voice_id, speed, vol, pitch, emotion, pronunciation_dict, audio_setting, subtitle_enable
 */
export function buildBody(params) {
  var input = (params.input || params.text || params.prompt || '').toString().trim()
  if (!input) throw new Error('input 必填')
  var body = {
    model: MODEL,
    input: input,
    voice: params.voice_id || params.voice || 'male-qn-qingse',
    voice_setting: params.voice_setting || defaultVoiceSetting(params),
    audio_setting: params.audio_setting || defaultAudioSetting(params),
    subtitle_enable: params.subtitle_enable === true
  }
  if (params.pronunciation_dict && typeof params.pronunciation_dict === 'object' && Array.isArray(params.pronunciation_dict.tone)) {
    body.pronunciation_dict = { tone: params.pronunciation_dict.tone }
  }
  return body
}
